const dynamicStrings = {
    GLOBAL_STATE: "globalState",
    CUSTOM: "custom",
    ROUTER_LINK: "routerLink:",
    TEXT_LINK: "textLink:",
};

export { dynamicStrings };
